module.exports = __webpack_public_path__ + "img/info_circle.2e38e87d.svg";